import React from "react";
import { View, Text, TextInput, Icon } from "ui";
import { styled, theme } from "styles";
import { Link } from "react-router-dom";

interface P {
  id: string;
  activeAlerts?: number;
  expiredAlerts?: number;
  title: string;
  image?: string;
  onClick?: () => void;
}

const MemoItem = ({
  id,
  onClick,
  title,
  image,
  expiredAlerts,
  activeAlerts
}: P) => {
  const imageDefault = require("assets/logo.png");

  return (
    <MemoCard
      m={1}
      bg="white"
      flexDirection="row"
      alignItems="center"
      justifyContent="space-between"
      px={1}
      py="3px"
      as={Link}
      to={`/app/memos/${id}`}
      onClick={onClick}
    >
      <View ml={2} flex={10} flexDirection="column">
        <Title color="black" fontSize={4}>
          {title}
        </Title>
        <View flexDirection="row" justifyContent="flex-start" mb={1}>
          <AlertsView
            bg="white"
            p={1}
            px={2}
            mt={1}
            borderRadius={10}
            alignItems="center"
            justifyContent="space-around"
            mr={2}
          >
            <Icon name="bell" color={theme.colors.warning} size={1.5} />
            <Text ml={1} fontSize={3} color="warning">
              {!expiredAlerts ? 0 : expiredAlerts}
            </Text>
          </AlertsView>

          <AlertsView
            bg="white"
            p={1}
            px={2}
            borderRadius={10}
            alignItems="center"
            justifyContent="space-around"
            mr={2}
          >
            <Icon name="bell" color="#f16541" size={1.5} />
            <Text ml={1} fontSize={3} color="primary">
              {!activeAlerts ? 0 : activeAlerts}
            </Text>
          </AlertsView>
        </View>
      </View>
      <Image src={image ? image : imageDefault} />
    </MemoCard>
  );
};

const Title = styled(Text)`
  font-weight: bold;
`;

const AlertsView = styled(View)`
  font-weight: bold;
  box-shadow: 0px 0 4px 1px grey;
  flex-shrink: 0;
`;

const MemoCard = styled(View)`
  box-shadow: 0px 5px 5px grey;
  cursor: pointer;
  text-decoration: none;
` as any;

const Image = styled.img`
  max-width: 3.5rem;
  max-height: 3.5rem;
  min-width: 3.5rem;
  min-height: 3.5rem;
  border-radius: 10px;
  object-fit: cover;
`;

export default MemoItem;



// WEBPACK FOOTER //
// ./src/components/MemoItem.tsx